import React from 'react';
import { Input, message } from 'antd';
import {
  DrawerForm,
  useFormField,
  Edit,
  useFormContext
} from '@unicus/react-ui-kit';

import { useDispatch } from 'react-redux';
import {
  updatePassword,
  savePassword,
  savePasswordFailed
} from 'stores/users/userActions';

const UpdatePassword = ({ visible = true, data = {}, loading }) => {
  const { editingPassword } = data;
  const dispatch = useDispatch();
  const { form } = useFormContext();
  const formField = useFormField(form);

  const onSuccess = () => {
    message.success('A senha foi alterada com sucesso.');
  };
  const onFail = () => {
    dispatch(savePasswordFailed());
  };

  const handleSave = () => {
    form.validateFields((err, values) => {
      if (err) {
        return;
      }

      if (values.newPassword !== values.passwordConfirmation) {
        message.warn('As senhas não coincidem.');
        return;
      }

      dispatch(savePassword(editingPassword.userId, values, onSuccess, onFail));
    });
  };

  const handleClose = () => {
    dispatch(updatePassword(null));
  };

  return (
    <DrawerForm
      title="Alterar senha"
      width={700}
      closable={false}
      onCancel={handleClose}
      onSubmit={handleSave}
      saving={loading}
      visible={visible}
      form={form}
      size="md"
    >
      {formField('currentPassword', 'Senha atual', {
        isRequired: true,
        labelCol: {
          sm: { span: 7 }
        },
        wrapperCol: {
          sm: { span: 17 }
        },
        style: { width: '100%' }
      })(<Input maxLength={30} type="password" />)}

      {formField('newPassword', 'Nova senha', {
        isRequired: true,
        labelCol: {
          sm: { span: 7 }
        },
        wrapperCol: {
          sm: { span: 17 }
        },
        style: { width: '100%' }
      })(<Input maxLength={30} type="password" />)}

      {formField('passwordConfirmation', 'Confirmação da senha', {
        isRequired: true,
        labelCol: {
          sm: { span: 7 }
        },
        wrapperCol: {
          sm: { span: 17 }
        },
        style: { width: '100%' }
      })(<Input maxLength={30} type="password" />)}
    </DrawerForm>
  );
};

export default Edit.create(UpdatePassword, { resource: 'users' });
